import { oidcConfig } from '../forgeiam/authConfig'

/**
 * Get the authentication token from session storage
 * @returns The ID token or empty string if not found
 */
export const getAuthToken = (): string => {
  const itemKey = `oidc.user:${oidcConfig.authority ?? ''}:${oidcConfig.client_id ?? ''}`
  const itemValue = sessionStorage.getItem(itemKey)

  if (itemValue == null) {
    return ''
  }

  try {
    const parsedValue = JSON.parse(itemValue)
    return (parsedValue?.id_token != null && parsedValue.id_token !== '') ? parsedValue.id_token : ''
  } catch (error) {
    // JSON parsing failed, return empty string as documented
    return ''
  }
}
